class PhotosStorage {
  constructor(middlePhoto) {
    this._photoList = [middlePhoto]
  }

  _findIndexByPhotoIdOrNull(photoId) {
    const index = this._photoList.findIndex((photo) => photo.id === photoId)
    return index === -1 ? null : index
  }

  getPreviousOrNull(photoPointId) {
    const photoIndex = this._findIndexByPhotoIdOrNull(photoPointId)
    if (photoIndex === null) return null
    return this._photoList[photoIndex - 1] || null
  }

  getNextOrNull(photoPointId) {
    const photoIndex = this._findIndexByPhotoIdOrNull(photoPointId)
    if (photoIndex === null) return null
    return this._photoList[photoIndex + 1] || null
  }

  insert(photos, middlePhotoId) {
    // Photos with negative keys go before, positive keys go after
    const newPhotosBeforeMiddle = Object.entries(photos)
      .filter(([key, photo]) => key < 0 && photo !== null)
      .sort(([keyA], [keyB]) => Number(keyB) - Number(keyA))
      .map(([, photo]) => photo)

    const newPhotosAfterMiddle = Object.entries(photos)
      .filter(([key, photo]) => key > 0 && photo !== null)
      .sort(([keyA], [keyB]) => Number(keyA) - Number(keyB))
      .map(([, photo]) => photo)

    const middlePhotoIndex = this._findIndexByPhotoIdOrNull(middlePhotoId)
    if (middlePhotoIndex === null) return

    const newPhotoList = this._photoList.slice(0, middlePhotoIndex)
    newPhotoList.push(...newPhotosBeforeMiddle)
    newPhotoList.push(this._photoList[middlePhotoIndex])
    newPhotoList.push(...newPhotosAfterMiddle)
    newPhotoList.push(...this._photoList.slice(middlePhotoIndex + 1))
    this._photoList = newPhotoList
  }

  update(photo) {
    const index = this._findIndexByPhotoIdOrNull(photo.id)
    if (index !== null) {
      this._photoList.splice(index, 1, photo)
    }
  }
}

export default PhotosStorage
